import { FC, useEffect } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Outlet } from 'react-router-dom';
import Middleware from '@/router/middleware/index.tsx';
import { passToRouteSearchParams } from '@/utils/passToRouteSearchParams.ts';
import SearchParams from '@/_constants/SearchParams.ts';

const IsLoggedIn: FC = () => {
  const { isLoading, user } = useAuthContext();

  const redirectUrl = passToRouteSearchParams(import.meta.env.VITE_AUTH_URL, {
    [SearchParams.RETURN_URL]: encodeURI(window.location.href),
  });

  useEffect(() => {
    if (!isLoading && !user) {
      window.location.href = redirectUrl;
    }
  }, [isLoading, redirectUrl, user]);

  return <Middleware isLoading={isLoading || !user}>{user ? <Outlet /> : null}</Middleware>;
};

export default IsLoggedIn;
